module.exports = __webpack_public_path__ + "static/media/sort-arrow-not-asc.896551ce.svg";